import { useEffect, useState } from 'react';

// Helpers for "what's happening now" on the agenda. Uses the device's clock
// and time zone — attendees checking the app are at the venue, so that's the
// meeting's local time.

const pad = (n) => String(n).padStart(2, '0');

// "2026-10-07" for the device's current local date.
export function localISODate(d) {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

// "14:05:00" — same 24h format as start24/end24 on agenda sessions, so plain
// string comparison orders them correctly.
export function localHMS(d) {
  return `${pad(d.getHours())}:${pad(d.getMinutes())}:00`;
}

// Re-renders every minute so "Now" markers move without a reload.
export function useNow() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60 * 1000);
    return () => clearInterval(id);
  }, []);
  return now;
}

// Normalize "14:05" / "14:05:00" to "14:05:00" so comparisons line up.
const norm = (t) => (t && t.length === 5 ? `${t}:00` : t || '');

// True while a session is under way (start ≤ now < end).
export function isLive(session, hms) {
  const start = norm(session.start24);
  const end = norm(session.end24);
  return Boolean(start && end && start <= hms && hms < end);
}

// True once a session has finished.
export function isOver(session, hms) {
  const end = norm(session.end24);
  return Boolean(end && end <= hms);
}

// Index of the agenda day that's today, or -1 when today isn't a meeting day.
export function todayDayIndex(agenda, now) {
  if (!agenda) return -1;
  const today = localISODate(now);
  return Object.values(agenda).findIndex((sessions) => sessions?.[0]?.date === today);
}
